"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @hidden
 */
exports.focusFirstFocusableChild = function (target) {
    if (target) {
        if ((target instanceof HTMLInputElement || target.tabIndex !== -1) && target.focus) {
            target.focus();
            return;
        }
        var element = target.querySelector('input, [tabindex]:not([tabindex="-1"])');
        if (element && element.focus) {
            element.focus();
        }
    }
};
//# sourceMappingURL=focus.js.map


//////////////////
// WEBPACK FOOTER
// /Users/larsmarin/Documents/Workspaces/AAG/aag-amc-projects/~/.pnpm/@progress+kendo-react-common@3.18.0_react-dom@16.14.0_react@16.14.0__react@16.14.0/~/@progress/kendo-react-common/dist/npm/focus.js
// module id = 6464
// module chunks = 0